module.exports = __webpack_public_path__ + "img/client-4.ce31eaa.png";